exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".instructions[data-v-2fbfa473]{margin-top:20px}.instructions[data-v-2fbfa473],.setup__range[data-v-2fbfa473]{box-sizing:border-box;width:100%}", ""]);

// exports
